<template>
	<div>
		<div @click.prevent="launchFilePicker">
			<input-button :btn-class="'btn-grey'">
				<slot></slot>
			</input-button>
		</div>
		<input type="file" id="chooseFile" name="chooseFile" style="display:none" ref="fileInput" @change="fileChanged" accept=".txt" />
	</div>
</template>

<script>	
	import InputButton from '../reusable/InputButton'

	export default {
		name: 'LoadSavedSearch',
		components: {
			InputButton
		},
		methods: {
			launchFilePicker() {
				this.$refs.fileInput.click();
			},
			fileChanged() {
				var totalFiles = this.$refs.fileInput.files;
				console.log(totalFiles);

// eslint-disable-next-line no-cond-assign
				for (var i = 0, f; f = totalFiles[i]; i++) {

					var reader = new FileReader();
					reader.onload = ((reader) => {
						return () => {
							var contents = reader.result;
							this.$emit('contentRead', contents)
						}
					})(reader);

					let filename = f.name;
					if (filename.match(/.txt$/)) reader.readAsText(f);
					else this.$emit('error', 'Can only load data from a .txt file');
				}				
			}
		}
	}
</script>

<style lang="scss" scoped>
	
</style>
